export default {"src":"/login-app/[GIT_HASH]/_next/static/media/ingest.6855cddd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};